export default __webpack_public_path__ + "static/media/georgia-logo.11f8a091.svg";